import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { KITCHEN_API_URL } from './kitchen-api.token';
import {
  ApiEnvelope,
  DispatchedItemDto,
  ItemStatusChangeRequestDto,
  ItemStatusChangeResponseDto,
  PageDto,
  SoldOutItemDto,
  TicketDto,
} from './kitchen-api.types';

@Injectable({ providedIn: 'root' })
export class KitchenApiService {
  private readonly http = inject(HttpClient);
  private readonly base = inject(KITCHEN_API_URL);

  private desenvolver<T>(fuente: Observable<ApiEnvelope<T>>): Observable<T> {
    return fuente.pipe(map((respuesta) => respuesta.data));
  }

  /** Comandas en espera y en preparacion, solo con los items que siguen en cocina. */
  listarComandasActivas(estacion: string | null): Observable<TicketDto[]> {
    return this.desenvolver(
      this.http.get<ApiEnvelope<TicketDto[]>>(`${this.base}/tickets`, { params: conEstacion(estacion) }),
    );
  }

  cambiarEstadoItems(body: ItemStatusChangeRequestDto): Observable<ItemStatusChangeResponseDto[]> {
    return this.desenvolver(
      this.http.patch<ApiEnvelope<ItemStatusChangeResponseDto[]>>(`${this.base}/items/status`, body),
    );
  }

  listarDespachados(estacion: string | null, pagina: number, tamano: number): Observable<PageDto<DispatchedItemDto>> {
    return this.desenvolver(
      this.http.get<ApiEnvelope<PageDto<DispatchedItemDto>>>(`${this.base}/items/dispatched`, {
        params: conEstacion(estacion).set('page', pagina).set('size', tamano),
      }),
    );
  }

  /** Insumos agotados: cocina los consulta a inventario. */
  listarAgotados(): Observable<SoldOutItemDto[]> {
    return this.desenvolver(this.http.get<ApiEnvelope<SoldOutItemDto[]>>(`${this.base}/sold-out`));
  }
}

function conEstacion(estacion: string | null): HttpParams {
  const params = new HttpParams();
  return estacion ? params.set('station', estacion) : params;
}
